import { db } from '../firebaseConfig';
import { collection, writeBatch, doc, getDocs } from 'firebase/firestore';

export const seedSatTaxTables = async () => {
  const taxTables = {
    Semanal: [
      { limInf: 0.01, limSup: 186.51, cuotaFija: 0.00, pct: 1.92 },
      { limInf: 186.52, limSup: 1583.01, cuotaFija: 3.58, pct: 6.40 },
      { limInf: 1583.02, limSup: 2782.00, cuotaFija: 92.96, pct: 10.88 },
      { limInf: 2782.01, limSup: 3233.95, cuotaFija: 223.41, pct: 16.00 },
      { limInf: 3233.96, limSup: 3871.93, cuotaFija: 295.72, pct: 17.92 },
      { limInf: 3871.94, limSup: 7809.12, cuotaFija: 410.05, pct: 21.36 },
      { limInf: 7809.13, limSup: 12308.25, cuotaFija: 1251.03, pct: 23.52 },
      { limInf: 12308.26, limSup: 23498.47, cuotaFija: 2309.29, pct: 30.00 },
      { limInf: 23498.48, limSup: 31331.30, cuotaFija: 5666.29, pct: 32.00 },
      { limInf: 31331.31, limSup: 93993.90, cuotaFija: 8172.79, pct: 34.00 },
      { limInf: 93993.91, limSup: 9999999.00, cuotaFija: 29478.08, pct: 35.00 }
    ],
    Catorcenal: [
      { limInf: 0.01, limSup: 347.00, cuotaFija: 0.00, pct: 1.92 },
      { limInf: 347.01, limSup: 2945.14, cuotaFija: 6.66, pct: 6.40 },
      { limInf: 2945.15, limSup: 5175.81, cuotaFija: 172.94, pct: 10.88 },
      { limInf: 5175.82, limSup: 6016.66, cuotaFija: 415.64, pct: 16.00 },
      { limInf: 6016.67, limSup: 7203.58, cuotaFija: 550.18, pct: 17.92 },
      { limInf: 7203.59, limSup: 14528.60, cuotaFija: 762.87, pct: 21.36 },
      { limInf: 14528.61, limSup: 22899.07, cuotaFija: 2327.27, pct: 23.52 },
      { limInf: 22899.08, limSup: 43718.09, cuotaFija: 4296.82, pct: 30.00 },
      { limInf: 43718.10, limSup: 58290.79, cuotaFija: 10542.50, pct: 32.00 },
      { limInf: 58290.80, limSup: 174872.38, cuotaFija: 15205.76, pct: 34.00 },
      { limInf: 174872.39, limSup: 9999999.00, cuotaFija: 54839.29, pct: 35.00 }
    ],
    Quincenal: [
      { limInf: 0.01, limSup: 373.02, cuotaFija: 0.00, pct: 1.92 },
      { limInf: 373.03, limSup: 3166.03, cuotaFija: 7.16, pct: 6.40 },
      { limInf: 3166.04, limSup: 5564.01, cuotaFija: 185.92, pct: 10.88 },
      { limInf: 5564.02, limSup: 6467.91, cuotaFija: 446.82, pct: 16.00 },
      { limInf: 6467.92, limSup: 7743.86, cuotaFija: 591.44, pct: 17.92 },
      { limInf: 7743.87, limSup: 15618.25, cuotaFija: 820.09, pct: 21.36 },
      { limInf: 15618.26, limSup: 24616.50, cuotaFija: 2502.06, pct: 23.52 },
      { limInf: 24616.51, limSup: 46996.95, cuotaFija: 4618.58, pct: 30.00 },
      { limInf: 46996.96, limSup: 62662.60, cuotaFija: 11332.59, pct: 32.00 },
      { limInf: 62662.61, limSup: 187987.81, cuotaFija: 16345.59, pct: 34.00 },
      { limInf: 187987.82, limSup: 9999999.00, cuotaFija: 58956.16, pct: 35.00 }
    ],
    Mensual: [
      { limInf: 0.01, limSup: 746.04, cuotaFija: 0.00, pct: 1.92 },
      { limInf: 746.05, limSup: 6332.05, cuotaFija: 14.32, pct: 6.40 },
      { limInf: 6332.06, limSup: 11128.01, cuotaFija: 371.83, pct: 10.88 },
      { limInf: 11128.02, limSup: 12935.82, cuotaFija: 893.63, pct: 16.00 },
      { limInf: 12935.83, limSup: 15487.71, cuotaFija: 1182.88, pct: 17.92 },
      { limInf: 15487.72, limSup: 31236.49, cuotaFija: 1640.18, pct: 21.36 },
      { limInf: 31236.50, limSup: 49233.00, cuotaFija: 5004.12, pct: 23.52 },
      { limInf: 49233.01, limSup: 93993.90, cuotaFija: 9237.16, pct: 30.00 },
      { limInf: 93993.91, limSup: 125325.20, cuotaFija: 22665.17, pct: 32.00 },
      { limInf: 125325.21, limSup: 375975.61, cuotaFija: 32691.18, pct: 34.00 },
      { limInf: 375975.62, limSup: 9999999.00, cuotaFija: 117912.32, pct: 35.00 }
    ]
  };

  const snap = await getDocs(collection(db, 'config_sat_tablas'));
  const batch = writeBatch(db);
  
  // Wipe existing
  snap.docs.forEach(d => batch.delete(d.ref));
  await batch.commit();

  // Write new
  const batchWrite = writeBatch(db);
  Object.keys(taxTables).forEach(periodType => {
    const docRef = doc(collection(db, 'config_sat_tablas'), periodType);
    batchWrite.set(docRef, {
      tipoPeriodo: periodType,
      rangos: taxTables[periodType],
      updatedAt: new Date()
    });
  });
  await batchWrite.commit();
  console.log("Tarifas del SAT inicializadas con éxito.");
};
